import axios from 'axios';
import { message } from 'antd';
// const BASE_URL = 'http://localhost:8083/api/v1';
const BASE_URL = 'http://45.252.248.156:8083/api/v1'; //prd
// const BASE_URL = 'http://45.252.248.156:8084/api/v1'; //dev
const $axios = axios.create({
	baseURL: BASE_URL,
	timeout: 30000,
	retry: 4,
	retryDelay: 1000
});

$axios.interceptors.request.use(function(config) {
	config.headers['Authorization'] = `Bearer ${localStorage.getItem('token') || null}`;
	return config;
}, function(error) {
	message.error(error);
	return Promise.reject(error);
});

$axios.interceptors.response.use(function(response) {
	if (response.data.success === false) {
		message.error(response.data.message);
	}
	return response.data;
}, function(error) {
	return Promise.reject(error.response);
});

export default $axios;
